import React, { useEffect, useState } from 'react';
import { IFormattedTextPageContent } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';
import Editor from '../../GenericForms/Editor';

interface IFormattedTextPageEditorProps extends IScreenEditorProps {
  content: IFormattedTextPageContent;
}

const FormattedTextPageEditor: React.FC<IFormattedTextPageEditorProps> = ({
  content,
  errors,
  onContentChange,
  onFilesChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<IFormattedTextPageContent>(content);

  useEffect(() => {
    setLocalContent(content);
  }, [content]);

  const updateContent = (updates: Partial<IFormattedTextPageContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    
    // Validate on change
    const validationErrors = validate(newContent);
    onValidationChange(validationErrors);
  };

  const validate = (contentToValidate: IFormattedTextPageContent = localContent): string[] => {
    const errors: string[] = [];
    if (!contentToValidate.title) errors.push('Page title is required');
    if (!contentToValidate.content) errors.push('Content is required');
    return errors;
  };

  return (
    <div className="form-section">
      <h4>Formatted Text Page Content</h4>
      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">Page Title*</label>
          <div className="col-sm-9">
            <input 
              type="text" 
              className="form-control" 
              value={localContent.title} 
              onChange={(e) => updateContent({ title: e.target.value })} 
              placeholder="Page title" 
            />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Show Table of Contents</label>
          <div className="col-sm-9">
            <input 
              type="checkbox" 
              checked={localContent.showTableOfContents} 
              onChange={(e) => updateContent({ showTableOfContents: e.target.checked })} 
            />
            <span className="ml-2">Generate table of contents from headings</span>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Content</label>
          <div className="col-sm-9">
            <Editor
              options="simple"
              height="normal"
              value={localContent.content}
              changed={(content: string) => updateContent({ content })}
              readOnly={false}
              placeholder="Enter your formatted content here..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormattedTextPageEditor;